import React, { useState } from 'react'
import FinanceLayout from '../../../../../../layout/components/FinanceLayout'
import InventoryTransferVoucherList from '../components/InventoryTransferVoucherList'

function InventoryTransferVoucherListPage() {
  


  return (
    <FinanceLayout>
        <InventoryTransferVoucherList/>
    </FinanceLayout>
  )
}

export default InventoryTransferVoucherListPage